/**
 * Where the session token lives. The web app needs none: the server sets an httpOnly
 * cookie the page can't read. The native app registers a Keychain-backed store at
 * startup, and the API client then sends the token as a Bearer header.
 */
export interface TokenStore {
  get(): Promise<string | null>
  set(token: string): Promise<void>
  clear(): Promise<void>
}

let store: TokenStore | null = null

export function setTokenStore(next: TokenStore | null): void {
  store = next
}

export function getTokenStore(): TokenStore | null {
  return store
}

export async function authHeaders(): Promise<Record<string, string>> {
  const token = await store?.get()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
